// extracted by mini-css-extract-plugin
export var link = "_rv-0";